import client from './client';
import type { Trial, TrialConfig, TrialStatus } from '../types/trial';

export async function activateTrial(): Promise<Trial> {
  const { data } = await client.post('/trial/activate');
  return data;
}

export async function getTrialStatus(): Promise<TrialStatus> {
  const { data } = await client.get('/trial/status');
  return data;
}

/** Публичные параметры триала — для текстов «N дней, M ГБ» до активации. */
export async function getTrialConfig(): Promise<TrialConfig> {
  const { data } = await client.get('/trial/config');
  return data;
}

/** Отвязать устройство от пробного ключа. */
export async function unbindTrialDevice(): Promise<void> {
  await client.delete('/trial/device');
}
